import { useNumberFormat } from '@react-input/number-format';
import { InputFieldConfig } from '@velocity-exchange/common/format';

type NumberFormatProps = NonNullable<Parameters<typeof useNumberFormat>[0]>;

/**
 * Renames the shared input config's digit caps to the mask library's own
 * option names. Everything else on the mask stays the caller's business.
 */
export function numberFormatPropsFromConfig(
	config: InputFieldConfig
): NumberFormatProps {
	return {
		locales: config.localeTag,
		maximumIntegerDigits: config.caps.maxIntegerDigits,
		maximumFractionDigits: config.caps.maxFractionDigits,
	};
}
